module.exports = __webpack_public_path__ + "img/82.10.pH.0716314b.png";